import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import useNewsFeed from '../hooks/useNewsFeed';

export default function NewsFeedList({ limit = 5 }) {
  const newsFeed = useNewsFeed();

  if (newsFeed.isError)
    return (
      <Typography variant="body2" color="textSecondary">
        {newsFeed.error?.message || 'Unable to load news'}
      </Typography>
    );

  if (newsFeed.isLoading) return null;

  return (
    <List dense>
      {newsFeed.data.slice(0, limit).map((m, idx) => {
        const hasTitle = !!m.title;
        const dateStr = new Date(m.createdAt).toLocaleDateString();
        return (
          <>
            <ListItem key={m.id} alignItems="flex-start">
              <ListItemText
                primary={dateStr}
                primaryTypographyProps={{ style: { fontWeight: 700 } }}
                secondary={
                  <>
                    {hasTitle && (
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 700, marginBottom: 4 }}
                      >
                        {m.title}
                      </Typography>
                    )}
                    {m.text}
                  </>
                }
              />
            </ListItem>
            {idx < newsFeed.data.length - 1 && <Divider component="li" />}
          </>
        );
      })}
    </List>
  );
}
